/**
 * Copyright 2016 Taito United Oy
 * All rights reserved.
 */

import PropTypes from 'prop-types';

import React, { PureComponent } from 'react';


import FacebookLogin from './FacebookLogin';
import GoogleLogin from './GoogleLogin';
// import ZeckitLogin from './ZeckitLogin';

// Styles
import './styles/LoginWidget.scss';

const propTypes = {
  country: PropTypes.string,
  identifier: PropTypes.string,
  onLogin: PropTypes.func.isRequired,
};

class LoginWidget extends PureComponent {
  _onLogin = authData => {
    const data = authData;
    const { country, identifier } = this.props;
    if (!country || !identifier) {
      this.props.onLogin(data);
      return;
    }

    data.country = country;
    data.identifier = identifier;
    this.props.onLogin(data);
  };

  render() {
    /* eslint-disable no-undef */
    return (
      <div styleName="LoginWidget">
        <div styleName="login">
          <div className="pure-u-1-1">
            {typeof FB !== typeof undefined && (
              <FacebookLogin
                facebook={FB}
                appId={process.env.FACEBOOK_APP_ID}
                onLogin={this._onLogin}
              />
            )}
            {typeof gapi !== typeof undefined && (
              <GoogleLogin
                google={gapi}
                clientId={process.env.GOOGLE_CLIENT_ID}
                onLogin={this._onLogin}
              />
            )}
            {/* Disable Zeckit-login for now. May come back later.
              ZITROADMAP-390
              */}
            {/* <ZeckitLogin onLogin={this._onLogin} /> */}
          </div>
        </div>
      </div>
    );

    /* eslint-enable no-undef */
  }
}

LoginWidget.propTypes = propTypes;

export default LoginWidget;
